<template>
    <div>
        <form-wizard
            title="Create an account"
            subtitle="Kindly provide the required details to proceed."
            color="#81b231"
            :finishButtonText="processing ? 'Processing...' : 'Complete'"
            @on-complete="thankYou"
        >
            <tab-content
                title="Personal Details"
                icon="fa fa-check"
                :before-change="setPersonal"
            >
                <div class="row">
                    <div class="col-md-12 col-lg-12 mt-10">
                        <form class="js-validation-signin">
                            <div>
                                <div class="form-group row">
                                    <div class="col-lg-6">
                                        <label for="firstname">FIRSTNAME</label>
                                        <input
                                            id="firstname"
                                            type="text"
                                            class="form-control"
                                            required
                                            name="firstname"
                                            placeholder="Enter firstname"
                                            autocomplete="phone"
                                            v-model="firstname"
                                        />
                                    </div>
                                    <div class="col-lg-6">
                                        <label for="lastname">LASTNAME</label>
                                        <input
                                            id="lastname"
                                            name="lastname"
                                            type="text"
                                            class="form-control"
                                            placeholder="Enter lastname"
                                            required
                                            autocomplete="phone"
                                            v-model="lastname"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-lg-6">
                                        <label for="phonw">PHONE</label>
                                        <input
                                            id="phone"
                                            type="text"
                                            class="form-control"
                                            required
                                            placeholder="Enter phone number"
                                            autocomplete="phone"
                                            v-model="phone"
                                        />
                                    </div>
                                    <div class="col-lg-6">
                                        <label for="email">EMAIL</label>
                                        <input
                                            id="email"
                                            type="text"
                                            class="form-control"
                                            required
                                            placeholder="Enter email address"
                                            autocomplete="email"
                                            v-model="email"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-lg-6">
                                        <label for="gender">GENDER</label>
                                        <select
                                            v-model="gender"
                                            name="gender"
                                            id="gender"
                                            class="form-control"
                                        >
                                            <option selected disabled value=""
                                                >-- Choose Gender --</option
                                            >
                                            <option value="Male">Male</option>
                                            <option value="Female"
                                                >Female</option
                                            >
                                            <option value="Others"
                                                >Others</option
                                            >
                                        </select>
                                    </div>
                                    <div class="col-lg-6">
                                        <label for="login-password"
                                            >DATE OF BIRTH</label
                                        >
                                        <input
                                            v-model="dob"
                                            type="date"
                                            class="js-datepicker form-control"
                                            id="example-datepicker3"
                                            name="example-datepicker3"
                                            data-week-start="1"
                                            data-autoclose="true"
                                            data-today-highlight="true"
                                            data-date-format="dd-mm-yyyy"
                                            placeholder="dd-mm-yyyy"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-lg-6">
                                        <label for="country">COUNTRY</label>
                                        <country-select
                                            class="form-control"
                                            v-model="country"
                                            :country="country"
                                            topCountry="US"
                                        />
                                    </div>
                                    <div class="col-lg-6">
                                        <label for="login-password"
                                            >STATE</label
                                        >
                                        <region-select
                                            class="form-control"
                                            v-model="region"
                                            :country="country"
                                            :region="region"
                                        />
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <div class="col-lg-6">
                                        <label for="firstname">ADDRESS</label>
                                        <input
                                            id="address"
                                            d
                                            type="text"
                                            class="form-control"
                                            required
                                            placeholder="Enter address"
                                            v-model="address"
                                        />
                                    </div>
                                    <div class="col-lg-6">
                                        <label for="lastname">CITY</label>
                                        <input
                                            id="city"
                                            type="text"
                                            class="form-control"
                                            placeholder="Enter city"
                                            required
                                            v-model="city"
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </tab-content>
            <tab-content title="Account" icon="fa fa-check">
                <div class="col-lg-12 mt-30">
                    <div class="form-group row">
                        <div class="col-lg-6">
                            <label for="gender">Preferred Account Type</label>
                            <select
                                v-model="account_type"
                                name="account_type"
                                id="account_type"
                                class="form-control"
                            >
                                <option selected disabled value=""
                                    >-- Choose Account Type --</option
                                >
                                <option value="SAVINGS">Savings Account</option>
                                <option value="JOIN">Joint Account</option>
                                <option value="CHECKING"
                                    >Checking Account</option
                                >
                                <option value="OFFSHORE"
                                    >OffShore Account</option
                                >
                            </select>
                        </div>
                        <div class="col-lg-6">
                            <label for="login-password"
                                >Preferred Account Currency</label
                            >
                            <select
                                class="form-control"
                                required
                                v-model="currency"
                            >
                                <option value="1">Euro (€)</option>
                                <option value="2">Pounds (£)</option>
                                <option value="3">Australian dollar ($)</option>
                                <option value="4"
                                    >New Zealand dollar ($)</option
                                >
                                <option value="5">Canadian dollar ($)</option>
                                <option value="6">Japanese yen (¥)</option>
                                <option value="7">Swiss franc (₣)</option>
                                <option value="8"
                                    >United States Dollar ($)</option
                                >
                            </select>
                        </div>
                    </div>
                </div>
            </tab-content>
            <tab-content
                title="Uploads"
                icon="fa fa-check"
                :before-change="register"
            >
                <div class="col-lg-10 mt-30">
                    <img
                        class="img-avatar img-avatar96"
                        :src="image_url ? image_url : default_image"
                    />
                    <form enctype="multipart/form-data">
                        <div class="form-group">
                            <label class="text-muted">
                                Upload Avatar
                            </label>
                            <small class="text-danger">required</small>

                            <div class="custom-file">
                                <input
                                    type="file"
                                    ref="file"
                                    class="custom-file-input"
                                    id="example-file-input-custom"
                                    name="example-file-input-custom"
                                    data-toggle="custom-file-input"
                                    @change="onAvatarChanged"
                                    accept=".jpeg, .jpg, .png"
                                    required
                                />
                                <label
                                    class="custom-file-label"
                                    for="example-file-input-custom"
                                    >Choose Avatar</label
                                >
                            </div>
                        </div>
                    </form>
                </div>
                <br />
                <hr />
                <div class="col-lg-10">
                    <form enctype="multipart/form-data">
                        <div class="form-group">
                            <label class="text-muted">
                                Upload ID
                            </label>
                            <small class="text-danger">required</small>
                            <div class="custom-file">
                                <input
                                    type="file"
                                    ref="file1"
                                    class="custom-file-input"
                                    name="example-file-input-custom"
                                    data-toggle="custom-file-input"
                                    @change="onFileChanged"
                                    required
                                />
                                <label
                                    class="custom-file-label"
                                    for="example-file-input-custom"
                                    >Choose File</label
                                >
                            </div>
                        </div>
                    </form>
                </div>
            </tab-content>

            <tab-content title="Completed" icon="fa fa-check">
                <div class="col-lg-12 mt-30">
                    <div class="py-30 text-center">
                        <h3 class="h3 font-w700 base-color mb-10">
                            Account created successfully!
                        </h3>
                        <h2 class="h5 font-w400 text-muted mb-50">
                            An email has been sent to your mailbox
                        </h2>
                    </div>
                </div>
            </tab-content>
        </form-wizard>
    </div>
</template>
<script>
import { RepositoryFactory } from "./../../repository/RepositoryFactory";
const AR = RepositoryFactory.get("users");
export default {
    props: ["group"],
    data() {
        return {
            processing: false,
            firstname: "",
            lastname: "",
            country: "",
            region: "",
            address: "",
            city: "",
            email: "",
            phone: "",
            dob: "",
            gender: "",
            default_image: "/media/avatars/avatar9.jpg",
            avatar: "",
            file: "",
            image_url: "",
            currency: 8,
            account_type: "SAVINGS"
        };
    },
    methods: {
        onAvatarChanged() {
            var uploadedFile = this.$refs.file.files[0];
            this.avatar = uploadedFile;
            this.image_url = URL.createObjectURL(uploadedFile);
            return;
        },
        onFileChanged() {
            var uploadedFile = this.$refs.file1.files[0];
            this.file = uploadedFile;
            return;
        },
        setPersonal() {
            if (
                this.firstname &&
                this.lastname &&
                this.phone &&
                this.country &&
                this.region &&
                this.dob &&
                this.gender &&
                this.email
            ) {
                toast.fire({
                    type: "success",
                    title: "Information saved successfully"
                });
                return true;
            } else {
                toast.fire({
                    type: "error",
                    title: "Ensure all fields are filled"
                });
                return false;
            }
        },
        async register() {
            if (!this.avatar) {
                toast.fire({
                    type: "error",
                    title: "Upload an avatar"
                });
                return false;
            }
            if (!this.file) {
                toast.fire({
                    type: "error",
                    title: "Upload an ID"
                });
                return false;
            }

            try {
                this.processing = true;

                var formData = new FormData();
                formData.append("avatar", this.avatar);
                formData.append("identity", this.file);
                formData.append("first_name", this.firstname);
                formData.append("last_name", this.lastname);
                formData.append("email", this.email);
                formData.append("dob", this.dob);
                formData.append("state", this.region);
                formData.append("country", this.country);
                formData.append("gender", this.gender);
                formData.append("phone", this.phone);
                formData.append("currency", this.currency);
                formData.append("account_type", this.account_type);
                formData.append("city", this.city);
                formData.append("address", this.address);

                await AR.userRegistration(formData);
                toast.fire({
                    type: "success",
                    title: "Registration successful"
                });
                this.processing = false;
                return true;
            } catch (error) {
                this.processing = false;
                console.log(error);
                if (error.response.status == 422) {
                    toast.fire({
                        type: "error",
                        title: error.response.data.errors.email[0]
                    });
                } else {
                    toast.fire({
                        type: "error",
                        title: "Something went wrong"
                    });
                }
            }
        },
        thankYou() {
            window.location = "/";
        }
    },
    created() {}
};
</script>
